import React from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';
import { LoginForm } from '../types';
import { useTenantStore } from '../store/tenantStore';

export const useAuth = () => {
  const queryClient = useQueryClient();
  const { setUser, setToken, logout: logoutStore, isAuthenticated } = useAuthStore();

  const loginMutation = useMutation({
    mutationFn: authService.login,
    onSuccess: (data) => {
      if (data.token && data.usuario) {
        setToken(data.token);
        setUser(data.usuario);
      }
    },
    onError: (error: any) => {
      
      // Manejar errores específicos
      if (error?.response?.status === 429) {
        
      } else if (error?.response?.status === 500) {
        
      }
    },
  });

  const { clearTenant } = useTenantStore();
  const logoutMutation = useMutation({
    mutationFn: authService.logout,
    onSuccess: () => {
      // Limpiar el cache de React Query
      queryClient.clear();
      // Limpiar el store
      logoutStore();
      clearTenant();
      // No redirigir aquí, dejar que el ProtectedRoute maneje la redirección
    },
    onError: (error) => {
      // Aún así, limpiar el cache y el store local
      queryClient.clear();
      logoutStore();
      clearTenant();
    },
  });

  const { data: currentUser, isLoading: isLoadingUser } = useQuery({
    queryKey: ['currentUser'],
    queryFn: authService.getCurrentUser,
    enabled: isAuthenticated,
    retry: 1,
    retryDelay: 1000,
  });

  // Efecto para manejar el usuario actual
  React.useEffect(() => {
    if (currentUser) {
      setUser(currentUser);
    }
  }, [currentUser, setUser]);

  const login = (credentials: LoginForm) => {
    return loginMutation.mutate(credentials);
  };

  const logout = () => {
    logoutMutation.mutate();
  };

  return {
    login,
    logout,
    currentUser: currentUser || null,
    isLoadingUser,
    isAuthenticated,
    isLoginLoading: loginMutation.isPending,
    isLogoutLoading: logoutMutation.isPending,
    loginError: loginMutation.error,
  };
}; 
